import React from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import "./Home.css";

// Assets
import neoLogo from "../../assets/images/Neo_Logo_A.svg";
import user1 from "../../assets/images/users/user-1.jpg";
import user2 from "../../assets/images/users/user-2.jpg";
import user3 from "../../assets/images/users/user-3.jpg";
import user4 from "../../assets/images/users/user-4.jpg";
import user5 from "../../assets/images/users/user-5.jpg";
import swimImg from "../../assets/images/swim.png";
import swim2Img from "../../assets/images/swim2.png";

const Home = () => {
  // Configuração dos 5 cards de features da imagem
  const features = [
    {
      title: "Ranking de alunos",
      icon: "mdi mdi-account-multiple-outline" // Duplo avatar outline
    },
    {
      title: "Ranking da equipe",
      icon: "mdi mdi-account-group-outline" // Grupo outline
    },
    {
      title: "Pontuação por presença",
      icon: "mdi mdi-star-outline" // Estrela outline fina
    },
    {
      title: "Renovação e evolução",
      icon: "mdi mdi-autorenew" // Setas circulares vazadas (outline)
    },
    {
      title: "Métricas em tempo real",
      icon: "mdi mdi-poll" // Gráfico de colunas vazado (outline)
    }
  ];

  // Dados reais dos Top Alunos da imagem
  const topAlunos = [
    { pos: 1, name: "Lucas Ferreira", score: "2.450", img: user1 },
    { pos: 2, name: "Mariana Lima", score: "2.150", img: user2 },
    { pos: 3, name: "Rafael Souza", score: "1.820", img: user3 },
    { pos: 4, name: "Juliana Costa", score: "1.620", img: user4 },
    { pos: 5, name: "Pedro Oliveira", score: "1.450", img: user5 }
  ];

  return (
    <div className="home-wrapper">
      {/* Botão Flutuante do Manual de Configuração */}
      <a
        href="/manual_configuracao.html"
        target="_blank"
        rel="noopener noreferrer"
        className="home-config-manual-btn"
      >
        <i className="mdi mdi-book-open-page-variant-outline"></i> Manual de Configuração
      </a>

      {/* 🌊 Vetores SVG de Ondas e Pontos Minimalistas de Fundo (Réplica Fiel da Imagem Original) */}
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1024 778"
        preserveAspectRatio="xMidYMid slice"
        className="home-bg-svg"
      >
        {/* Ondas do Canto Superior Direito (Curvas Suaves Bezier) */}
        <path
          d="M 667 50 C 730 65, 760 85, 794 79 C 830 73, 850 55, 910 51 C 950 48, 960 62, 985 68"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.4"
          strokeLinecap="round"
        />
        <path
          d="M 679 33 C 730 46, 760 58, 812 53 C 840 50, 850 36, 928 36 C 960 36, 970 43, 999 41"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.4"
          strokeLinecap="round"
        />
        <path
          d="M 655 67 C 718 80, 748 100, 782 94 C 820 88, 840 70, 900 66 C 940 63, 950 77, 972 83"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.25"
          strokeLinecap="round"
        />

        {/* Ondas Fluidas do Centro (Por trás dos Nadadores e Cards) */}
        <path
          d="M 380 400 C 450 380, 520 450, 600 420 C 680 390, 720 460, 780 440"
          fill="none"
          stroke="#e2661c"
          strokeWidth="2.5"
          strokeOpacity="0.18"
          strokeLinecap="round"
        />
        <path
          d="M 280 180 C 350 200, 420 160, 500 190 C 580 220, 640 180, 720 200"
          fill="none"
          stroke="#e2661c"
          strokeWidth="2"
          strokeOpacity="0.13"
          strokeLinecap="round"
        />

        {/* Ondas do Canto Inferior Esquerdo (Curvas Suaves Bezier) */}
        <path
          d="M 141 728 C 180 730, 220 730, 254 710 C 273 700, 300 700, 319 705 C 335 710, 345 715, 356 720"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.35"
          strokeLinecap="round"
        />
        <path
          d="M 126 708 C 170 710, 210 710, 254 687 C 270 680, 310 680, 327 687 C 335 690, 340 693, 344 696"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.35"
          strokeLinecap="round"
        />
        <path
          d="M 111 688 C 150 690, 190 690, 234 667 C 250 660, 290 660, 307 667 C 315 670, 320 673, 330 676"
          fill="none"
          stroke="#e2661c"
          strokeWidth="3"
          strokeOpacity="0.2"
          strokeLinecap="round"
        />

        {/* 🟡 Pontos Decorativos Elegantes Espalhados (Laranja Ativo e Chocolate Brown) */}
        <circle cx="80" cy="220" r="4" fill="#e2661c" opacity="0.35" />
        <circle cx="120" cy="180" r="6" fill="#482712" opacity="0.15" />
        <circle cx="45" cy="300" r="3" fill="#e2661c" opacity="0.25" />
        
        <circle cx="480" cy="250" r="5" fill="#e2661c" opacity="0.3" />
        <circle cx="530" cy="380" r="3" fill="#482712" opacity="0.2" />
        <circle cx="390" cy="480" r="6" fill="#e2661c" opacity="0.25" />
        <circle cx="580" cy="120" r="4.5" fill="#482712" opacity="0.15" />
        
        <circle cx="180" cy="650" r="5" fill="#e2661c" opacity="0.3" />
        <circle cx="280" cy="600" r="3" fill="#482712" opacity="0.2" />
        <circle cx="80" cy="580" r="4" fill="#e2661c" opacity="0.2" />
        
        <circle cx="940" cy="320" r="5.5" fill="#e2661c" opacity="0.2" />
        <circle cx="890" cy="150" r="3" fill="#482712" opacity="0.15" />
        <circle cx="920" cy="520" r="4.5" fill="#e2661c" opacity="0.25" />
        <circle cx="840" cy="640" r="3.5" fill="#482712" opacity="0.2" />
      </svg>

      {/* Grid container para colocar Lado a Lado de forma responsiva */}
      <div className="home-container">

        {/* Coluna Esquerda: Texto e Features de Gamificação */}
        <div className="home-left-column">

          {/* LOGO NEO REAL (Topo Esquerdo) */}
          <div className="mb-5">
            <img
              src={neoLogo}
              alt="NEO"
              className="home-logo"
            />
          </div>

          {/* RÓTULO "NOVO MÓDULO" + ONDA */}
          <div className="home-new-module">
            <span>Novo Módulo</span>
            <svg width="60" height="8" viewBox="0 0 60 8" fill="none" className="mt-1">
              <path
                d="M0 4 C10 0, 20 8, 30 4 C40 0, 50 8, 60 4"
                stroke="#e2661c"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {/* TÍTULO PRINCIPAL */}
          <h1 className="home-title">
            Conheça nosso<br />
            novo módulo de<br />
            <span style={{ color: "#e2661c" }}>Gamificação</span>
          </h1>

          {/* SUBTÍTULO */}
          <p className="home-subtitle">
            Engaje seu time e seus alunos com rankings, pontuação, metas e métricas de desempenho.
          </p>

          {/* GRID DE CARDS DE ATRIBUTOS */}
          <div className="home-features-grid">
            {features.map((feat, idx) => (
              <div key={idx} className="home-feature-card">
                <i className={feat.icon} />
                <span>{feat.title}</span>
              </div>
            ))}
          </div>

          {/* BOTÃO "SAIBA MAIS" */}
          <Link
            to="/settings/gamification"
            className="btn btn-lg rounded-pill px-5 py-2.5 d-inline-flex align-items-center gap-2 home-saiba-mais-btn"
          >
            Saiba mais <i className="mdi mdi-arrow-right font-size-18"></i>
          </Link>

        </div>

        {/* Coluna Direita: Grid de 2 Colunas de Widgets Promocionais (Lado a Lado Responsivo) */}
        <div className="home-right-column">
          {/* Sub-coluna 1: Top Alunos e Equipe */}
          <div className="home-sub-column">
            {/* CARD 1: TOP ALUNOS */}
            <div className="home-widget-card">
              {/* Header: Trophy + TOP ALUNOS */}
              <div className="d-flex align-items-center gap-2 mb-4">
                <i className="mdi mdi-trophy-outline font-size-24" style={{ color: "#e2661c" }} />
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: "14px",
                    color: "#482712",
                    letterSpacing: "1px",
                    textTransform: "uppercase"
                  }}
                >
                  Top Alunos
                </span>
              </div>

              {/* List of Students */}
              <div className="d-flex flex-column">
                {topAlunos.map((aluno, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center justify-content-between py-2"
                    style={{
                      borderBottom: idx < 4 ? "1px solid rgba(72, 39, 18, 0.08)" : "none"
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      {/* Ranking Number */}
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "15px",
                          color: "#482712",
                          width: "16px"
                        }}
                      >
                        {aluno.pos}
                      </span>
                      {/* Avatar Photo */}
                      <img
                        src={aluno.img}
                        alt={aluno.name}
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          objectFit: "cover"
                        }}
                      />
                      {/* Student Name */}
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#482712"
                        }}
                      >
                        {aluno.name}
                      </span>
                    </div>
                    {/* Student Score (Orange) */}
                    <span
                      style={{
                        color: "#e2661c",
                        fontWeight: 800,
                        fontSize: "15px"
                      }}
                    >
                      {aluno.score}{" "}
                      <span style={{ fontSize: "11px", fontWeight: 500 }}>pts</span>
                    </span>
                  </div>
                ))}
              </div>

              {/* Footer Label Estático: Ver ranking completo */}
              <div
                className="rounded-pill mt-3 w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                style={{
                  background: "rgba(72, 39, 18, 0.04)",
                  border: "1px solid rgba(72, 39, 18, 0.08)",
                  color: "#482712",
                  fontWeight: 700,
                  fontSize: "13px",
                  cursor: "default",
                  userSelect: "none"
                }}
              >
                Ver ranking completo <i className="mdi mdi-arrow-right"></i>
              </div>
            </div>

            {/* CARD 2: EQUIPE */}
            <div className="home-widget-card">
              {/* Header: EQUIPE + Icon Top Right */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: "14px",
                    color: "#482712",
                    letterSpacing: "1px",
                    textTransform: "uppercase"
                  }}
                >
                  Equipe
                </span>
                <div
                  style={{
                    background: "rgba(226, 102, 28, 0.06)",
                    border: "1px solid rgba(226, 102, 28, 0.18)",
                    borderRadius: "10px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i className="mdi mdi-account-group-outline font-size-18" style={{ color: "#e2661c" }} />
                </div>
              </div>

              {/* Content: SVG Progress Donut + Stats List */}
              <div className="d-flex align-items-center justify-content-between gap-4">

                {/* Circular SVG Donut Chart (86% Engajamento) */}
                <div className="position-relative" style={{ width: "110px", height: "110px", flexShrink: 0 }}>
                  <svg width="110" height="110" viewBox="0 0 110 110">
                    {/* Background Circle */}
                    <circle
                      cx="55"
                      cy="55"
                      r="45"
                      fill="transparent"
                      stroke="rgba(226, 102, 28, 0.08)"
                      strokeWidth="9"
                    />
                    {/* Foreground Circle (86%) */}
                    <circle
                      cx="55"
                      cy="55"
                      r="45"
                      fill="transparent"
                      stroke="#e2661c"
                      strokeWidth="9"
                      strokeDasharray="282.7"
                      strokeDashoffset="39.6"
                      strokeLinecap="round"
                      transform="rotate(-90 55 55)"
                      style={{ transition: "stroke-dashoffset 1s ease" }}
                    />
                  </svg>
                  {/* Centered Text inside Circle */}
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center"
                    style={{
                      inset: 0,
                      fontFamily: "Outfit, sans-serif",
                      lineHeight: 1
                    }}
                  >
                    <span style={{ fontSize: "20px", fontWeight: 900, color: "#482712" }}>86%</span>
                  </div>
                </div>

                {/* Stats List */}
                <div className="d-flex flex-column gap-3 flex-grow-1" style={{ paddingLeft: "8px" }}>
                  <div className="d-flex align-items-center">
                    <span style={{ color: "#be5a1e", fontWeight: 800, fontSize: "20px", width: "56px", display: "inline-block", flexShrink: 0 }}>78%</span>
                    <span style={{ color: "#482712", fontSize: "14px", fontWeight: 600, opacity: 0.9, lineHeight: "1.2" }}>
                      Presença média
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span style={{ color: "#be5a1e", fontWeight: 800, fontSize: "20px", width: "56px", display: "inline-block", flexShrink: 0 }}>92%</span>
                    <span style={{ color: "#482712", fontSize: "14px", fontWeight: 600, opacity: 0.9, lineHeight: "1.2" }}>
                      Metas atingidas
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span style={{ color: "#be5a1e", fontWeight: 800, fontSize: "20px", width: "56px", display: "inline-block", flexShrink: 0 }}>+14%</span>
                    <span style={{ color: "#482712", fontSize: "14px", fontWeight: 600, opacity: 0.9, lineHeight: "1.2" }}>
                      Evolução mensal
                    </span>
                  </div>
                </div>

              </div>

            </div>
          </div>

          {/* Sub-coluna 2: Pontos Totais e Evolução da Equipe */}
          <div className="home-sub-column">
            {/* CARD 3: PONTOS TOTAIS */}
            <div className="home-widget-card">
              {/* Header: PONTOS TOTAIS + Icon Top Right */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: "14px",
                    color: "#482712",
                    letterSpacing: "1px",
                    textTransform: "uppercase"
                  }}
                >
                  Pontos Totais
                </span>
                <div
                  style={{
                    background: "rgba(226, 102, 28, 0.06)",
                    border: "1px solid rgba(226, 102, 28, 0.18)",
                    borderRadius: "10px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i className="mdi mdi-star-outline font-size-18" style={{ color: "#e2661c" }} />
                </div>
              </div>

              {/* Main Number + Growth Subtext */}
              <div className="d-flex flex-column mb-3">
                <h2
                  style={{
                    fontSize: "38px",
                    fontWeight: 950,
                    color: "#482712",
                    margin: 0,
                    fontFamily: "Outfit, sans-serif",
                    lineHeight: 1,
                    letterSpacing: "-1px"
                  }}
                >
                  12.850
                </h2>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#482712",
                    marginTop: "6px"
                  }}
                >
                  <span style={{ color: "#4ba158", fontWeight: 800 }}>+18%</span> vs mês anterior
                </span>
              </div>

              {/* Sparkline SVG Chart */}
              <div style={{ height: "85px", marginTop: "15px" }}>
                <svg width="100%" height="85" viewBox="0 0 340 85" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="sparklineGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#e2661c" stopOpacity="0.25" />
                      <stop offset="100%" stopColor="#e2661c" stopOpacity="0.0" />
                    </linearGradient>
                  </defs>
                  {/* Gradient Fill Path */}
                  <path
                    d="M 10 75 C 50 65, 80 50, 110 52 C 140 54, 160 40, 190 42 C 220 44, 240 25, 270 28 C 300 30, 315 15, 330 12 L 330 85 L 10 85 Z"
                    fill="url(#sparklineGrad)"
                  />
                  {/* Wavy Line Path */}
                  <path
                    d="M 10 75 C 50 65, 80 50, 110 52 C 140 54, 160 40, 190 42 C 220 44, 240 25, 270 28 C 300 30, 315 15, 330 12"
                    fill="none"
                    stroke="#e2661c"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                  {/* End Highlight Dot */}
                  <circle cx="330" cy="12" r="4" fill="#e2661c" />
                </svg>
              </div>
            </div>

            {/* CARD 4: EVOLUÇÃO DA EQUIPE */}
            <div className="home-widget-card">
              {/* Header: EVOLUÇÃO DA EQUIPE + Icon Top Right */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: "14px",
                    color: "#482712",
                    letterSpacing: "1px",
                    textTransform: "uppercase"
                  }}
                >
                  Evolução da Equipe
                </span>
                <div
                  style={{
                    background: "rgba(226, 102, 28, 0.06)",
                    border: "1px solid rgba(226, 102, 28, 0.18)",
                    borderRadius: "10px",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i className="mdi mdi-poll font-size-18" style={{ color: "#e2661c" }} />
                </div>
              </div>

              {/* Custom Column Bar Chart (JAN to JUN) */}
              <div className="d-flex align-items-end position-relative" style={{ height: "120px", paddingLeft: "12px" }}>
                {/* Left Subtle Dotted Vertical Line Axis */}
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: "22px",
                    borderLeft: "1px dashed rgba(72, 39, 18, 0.15)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    paddingLeft: "4px"
                  }}
                >
                  <span style={{ fontSize: "7px", color: "#482712", opacity: 0.4 }}>•</span>
                  <span style={{ fontSize: "7px", color: "#482712", opacity: 0.4 }}>•</span>
                  <span style={{ fontSize: "7px", color: "#482712", opacity: 0.4 }}>•</span>
                  <span style={{ fontSize: "7px", color: "#482712", opacity: 0.4 }}>•</span>
                </div>

                {/* Bars Row container */}
                <div className="d-flex justify-content-between align-items-end flex-grow-1" style={{ paddingLeft: "10px" }}>
                  {[
                    { month: "JAN.", height: "45px" },
                    { month: "FEV.", height: "70px" },
                    { month: "MAR.", height: "55px" },
                    { month: "ABR.", height: "70px" },
                    { month: "MAI.", height: "85px" },
                    { month: "JUN.", height: "95px" }
                  ].map((item, idx) => (
                    <div key={idx} className="d-flex flex-column align-items-center gap-2">
                      <div
                        style={{
                          width: "18px",
                          height: item.height,
                          background: "linear-gradient(to top, rgba(226, 102, 28, 0.15), #e2661c)",
                          borderRadius: "4px 4px 0 0",
                          transition: "all 0.3s ease"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = "scaleY(1.05)";
                          e.currentTarget.style.filter = "brightness(1.1)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = "scaleY(1)";
                          e.currentTarget.style.filter = "none";
                        }}
                      />
                      <span
                        style={{
                          fontSize: "10px",
                          fontWeight: 800,
                          color: "#482712",
                          opacity: 0.9,
                          letterSpacing: "0.5px"
                        }}
                      >
                        {item.month}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Imagem do Nadador com Fundo Transparente no Canto Inferior Direito */}
        <img
          src={swimImg}
          alt="Swimmer"
          className="home-swimmer-bottom"
        />

        {/* Imagem Swim2 de Fundo */}
        <img
          src={swim2Img}
          alt="Swim Background"
          className="home-swimmer-bg"
        />

      </div>
    </div>
  );
};

export default withRouter(Home);
